import { Link, useLocation } from "react-router-dom";
import { BUSINESS_DETAILS } from "../../constants/social.constants";
// import { LANGUAGE } from "../../localization";
import SocialMediaLinks from "../Social-Media-Links/Social-Media-Links";
import { useState } from "react";
import './Navbar.css';

const Navbar = ({ isShowTopNavbar = false }) => {
    // const texts = LANGUAGE();
    const { pathname } = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false); // State to track menu open/close
    const [isSubMenuOpen, setIsSubMenuOpen] = useState(false); // State to track menu open/close

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const toggleSubMenu = () => {
        console.log(isSubMenuOpen)
        setIsSubMenuOpen(!isSubMenuOpen);
    };

    return (
        <header id="masthead" className="header ttm-header-style-03 fixed-header">
            <div id="site-header-menu" className="site-header-menu">
                <div className="site-header-menu-inner ttm-bgcolor-white">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="site-navigation d-flex flex-row align-items-center justify-content-between">
                                    <div className="row">
                                        <div className="site-branding">
                                            <Link className="home-link" to="/" title={BUSINESS_DETAILS.businessShortName} rel="home">
                                                <div className="logo-container">
                                                    <img id="logo-img" className="navbar-logo-img" src="/images/logo-2.jpeg" alt="kritajna-homes-logo" />
                                                    <div className="red-overlay"></div>
                                                </div>
                                            </Link>
                                        </div>

                                        <div
                                            style={{
                                                height: '59px',
                                                width: '1px',
                                                backgroundColor: '#4e4e4e',
                                                left: 0,
                                                display: 'block',
                                                marginLeft: '16px'
                                            }}
                                        />

                                        <div className="header_extra d-flex flex-row align-items-center justify-content-end">
                                            <div className="cmt-widget_header d-flex flex-row justify-content-between">
                                                <div className="widget_info d-flex flex-row align-items-center justify-content-end">
                                                    <div className="social-icons">
                                                        <SocialMediaLinks />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="d-flex flex-row">
                                        <div onClick={toggleMenu} className={`menu-toggle-button btn-show-menu-mobile menubar menubar--squeeze ${isMenuOpen ? "is-active" : ""}`}>
                                            <span className="menubar-box">
                                                <span className="menubar-inner"></span>
                                            </span>
                                        </div>
                                        <nav className={`main-menu menu-mobile ${isMenuOpen ? "open" : ""}`} id="menu">
                                            <ul className="menu">
                                                <li className={`mega-menu-item ${pathname === "/" ? "active" : ""}`} style={{ color: 'white' }}>
                                                    <Link className="nav-link-custom" to="/">Home</Link>
                                                </li>
                                                <li onClick={toggleSubMenu} className={`mega-menu-item ${isSubMenuOpen ? "open" : ""}`} style={{ color: 'white' }}>
                                                    <Link to="#" className={`mega-menu-link nav-link-custom ${pathname === "#" ? "active" : ""}`}>Services</Link>
                                                    <ul className={`mega-submenu ${isSubMenuOpen ? "active" : ""}`}>
                                                        <li><Link to="/architecture" >Architecture</Link></li>
                                                        <li><Link to="/interior">Interior Work</Link></li>
                                                        <li><Link to="/layouts">2D/3D Layouts</Link></li>
                                                        <li><Link to="/project-development">Project Development</Link></li>
                                                    </ul>
                                                </li>
                                                <li className={`mega-menu-item ${pathname === "/projects" ? "active" : ""}`} style={{ color: 'white' }}>
                                                    <Link className="nav-link-custom" to="/projects">Projects</Link>
                                                </li>
                                                <li className={`mega-menu-item ${pathname === "/contact-us" ? "active" : ""}`}>
                                                    <Link className="nav-link-custom" to="/contact-us">Contact Us</Link>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </header>
    );
}

export default Navbar;